import {Component, OnDestroy} from '@angular/core';
import {Subscription} from 'rxjs';

@Component({
  template: ''
})
/**
 * Provide some common functionality for all components
 */
export class BaseComponent implements OnDestroy {
  ///////////////////////////
  // BEGIN - Observable Subscription management

  protected subscriptions = new Array<Subscription>();

  /**
   * Add subscription so it can be unsubscribed when component is destroyed.
   * This is critical, otherwise memory leaks can occur.
   * @param sub
   */
  protected addSubscription(sub: Subscription) {
    this.subscriptions.push(sub);
  }

  /**
   * Unsubscribe all observable subscriptions added through addSubscription() method.
   * This is called in ngOnDestroy() life cycle hook of the BaseComponent class.
   */
  protected unsubscribeAll() {
    this.subscriptions.forEach(sub => {
      if (sub) {
        sub.unsubscribe();
      }
    });
  }

  // END - Observable Subscription management
  ////////////////////////////////////////////////

  /**
   * IMPORTANT!!!  If you override this hook in subclass, be sure to call super.ngOnDestroy() last to run this method.
   */
  ngOnDestroy() {
    // Clean up registered subscriptions.
    this.unsubscribeAll();
  }
}
